import React, {FC, useCallback, useId, useRef, useState, useEffect} from 'react'
import { createPortal } from 'react-dom'
import {
  DropDown,
  OptionsWrapper,
  Option,
  Container,
  ImgArrow,
  ItemText,
  ItemTextSmall,
  PropContainer,
  Prop,
  PropsWrapper,
  PropMulti,
  SelectInput,
  ItemFlavor,
  Categorytitle,
  ItemTextTitle,
  SearchField,
  SearchInput,
  MultiCheck,
  ControlContent,
  SelectedValue,
  SelectActions,
} from './styles'
import ArrowDown from './arrow-down.svg'
import Label from '../label';
import { icons } from '../../icons';
import { ErrorText } from '../input/styles';
import { BodyDefault, VerySmall } from '../typography/styled';
import { useTranslation } from 'react-i18next';
import { useTheme } from 'styled-components';
import { getIn } from 'formik';

type SelectProps = {
  data: any[],
  selectedValue:any;
  onChange: (selected:any) => void;
  isSmall?: boolean,
  title:string,
  toolTip?:any,
  multi?:boolean,
  disabled?:boolean,
  customStyles?:any,
  customDropStyles?:any,
  disabledText?:string,
  multipleOnChange?:(value:any) => void,
  autoComplete?:boolean,
  fieldName?:string,
  errors?:any,
  touched?:any,
  bootImage?:any,
  placeholder?:any,
  hasSearch?:boolean,
  categories?:any[],
  tooltipText?:string,
  required?:boolean,
  test_id?:string,
  isRegion?:boolean,
  renderInPortal?: boolean,
  /** Hide the visible label; the title is still announced to screen readers. */
  hideTitle?: boolean,
}
type ListItem = {
  title:string,
  id:any,
  options?:any[],
  icon?:any,
  isSmall?: boolean,
  onChange?: (selected:any) => void;
  value?:any,
}
const Select:FC<SelectProps> = (props) => {
  const [t] = useTranslation()
  const inputRef:any = useRef()
  const inputRefSearch:any = useRef()
  const selectRef:any = useRef()
  const dropRef:any = useRef()
  const droppedRef = useRef<HTMLDivElement>(null);
  const [active, setActive] = useState<boolean>(false)
  const [searchString, setSearchString] = useState<string>('')
  const [selected, setSelected] = useState<any>(null)
  const [height, setheight] = useState<any>()
  const [dropdownPosition, setDropdownPosition] = useState<React.CSSProperties>({})
  const optionsId = useId()

  useEffect(() => {
    if (!active) {
      return
    }

    const handleClickOutside = (event:any) => {
      if (
        selectRef.current &&
        !selectRef.current.contains(event.target) &&
        !droppedRef.current?.contains(event.target)
      ){
        setActive(false)
      }
    }

		document.addEventListener('click', handleClickOutside, true);
		return () => document.removeEventListener('click', handleClickOutside, true);
  },[active]);
  const {
    data,
    selectedValue,
    onChange,
    isSmall,
    title,
    hideTitle,
    toolTip=false,
    customStyles,
    multi=false,
    disabled,
    errors,
    fieldName,
    bootImage,
    placeholder,
    multipleOnChange,
    hasSearch,
    categories,
    customDropStyles,
    tooltipText,
    required,
    test_id,
    isRegion,
    renderInPortal = false,
  } = props
  useEffect(() => {
    if (disabled) {
      setActive(false)
    }
  }, [disabled])
  const fieldError = fieldName ? getIn(errors, fieldName) : undefined;
  const changeValue = (value:any) => {
    if(value?.ocupado){
      return
    }
    if(multi && multipleOnChange){
      multipleOnChange(value)
      setSearchString('')
    } else if(hasSearch) {
      onChange(value)
      setSearchString('')
      setActive(false)
      // setSearchString(selected?.label)

    } else {
      onChange(value)
      setActive(false)
    }
  }
  const handleMultiInputKeyDown = (event:React.KeyboardEvent<HTMLInputElement>) => {
    if (
      event.key === 'Backspace' &&
      multi &&
      selectedValue?.length !== 0 &&
      searchString?.length === 0
    ) {
     changeValue(selectedValue?.[selectedValue?.length - 1])
   }
  };
  useEffect(() => {
    setSelected(data?.length > 0 && data.find((item:ListItem) => (item.id !== undefined && item.id === selectedValue) || item.value === selectedValue))
  },[data, selectedValue])
  useEffect(() => {
    if(searchString.length !== 0){
      setActive(true)
    }
  },[searchString])
  useEffect(() => {
    setheight(selectRef?.current?.offsetHeight)
  }, [active, multi, selectedValue])
  useEffect(() => {
    if (!active) {
      return
    }

    const input = multi ? inputRef.current : hasSearch ? inputRefSearch.current : null
    input?.focus()
  }, [active, hasSearch, multi])

  const handleComboboxKeyDown = (event:React.KeyboardEvent<HTMLDivElement>) => {
    if (event.key === 'Escape') {
      setActive(false)
      return
    }
    if (event.target instanceof HTMLInputElement) {
      return
    }
    if (event.key === 'Enter' || event.key === ' ' || event.key === 'ArrowDown') {
      event.preventDefault()
      setActive(true)
    }
  }
  const checkSelectContainerPosition = useCallback(() => {
    const windowHeight = window.innerHeight;
    const selectContainer = dropRef.current;
    const containerPosition = selectContainer?.getBoundingClientRect();
    if(containerPosition === undefined){
      return 
    }
    if (renderInPortal) {
      const dropdownHeight = droppedRef.current?.getBoundingClientRect()?.height || 354;
      const showAbove = containerPosition?.bottom && dropdownHeight + containerPosition.bottom + 6 > windowHeight;
      const viewportGutter = 16;
      const availableWidth = Math.max(0, window.innerWidth - viewportGutter * 2);
      const dropdownWidth = Math.min(containerPosition.width, availableWidth);
      const maxLeft = Math.max(viewportGutter, window.innerWidth - viewportGutter - dropdownWidth);
      const dropdownLeft = Math.min(Math.max(containerPosition.left, viewportGutter), maxLeft);
      const position: React.CSSProperties = {
        position: 'fixed',
        left: `${dropdownLeft}px`,
        width: `${dropdownWidth}px`,
        zIndex: 9999,
      };

      if (showAbove) {
        position.bottom = `${windowHeight - containerPosition.top + 6}px`;
        position.marginTop = 0;
      } else {
        position.top = `${containerPosition.bottom + 6}px`;
        position.marginTop = 0;
      }

      setDropdownPosition(position)
    } else {
      if (containerPosition?.bottom && (droppedRef.current?.getBoundingClientRect()?.height + containerPosition.bottom) > windowHeight) {
        droppedRef.current?.style.setProperty('bottom', `${height-18}px`);
      } else {
        droppedRef.current?.style.setProperty('bottom', `auto`);
        droppedRef.current?.style.setProperty('margin-top', '6px');
      }
    }
  }, [height, renderInPortal]);
  useEffect(() => {
    if (!active) {
      return
    }

    let animationFrame:number | undefined
    const updatePosition = () => {
      if (animationFrame !== undefined) {
        cancelAnimationFrame(animationFrame)
      }
      animationFrame = requestAnimationFrame(checkSelectContainerPosition)
    }

    checkSelectContainerPosition()
    window.addEventListener('scroll', updatePosition, true)
    window.addEventListener('resize', updatePosition)
    return () => {
      if (animationFrame !== undefined) {
        cancelAnimationFrame(animationFrame)
      }
      window.removeEventListener('scroll', updatePosition, true)
      window.removeEventListener('resize', updatePosition)
    }
  }, [active, checkSelectContainerPosition]);
  const theme:any = useTheme()
  return (
    <Container customStyles={customStyles} isRegion={isRegion} ref={selectRef}>
      {isSmall || isRegion || hideTitle ? null :
        <div style={{marginBottom:"4px"}}>
          <Label required={required} tooltipText={tooltipText} toolTip={toolTip} title={title}/>
        </div>
      }
      <DropDown
        role="combobox"
        aria-label={hideTitle ? title : undefined}
        tabIndex={disabled ? -1 : 0}
        aria-disabled={disabled}
        aria-expanded={active && !disabled}
        aria-controls={optionsId}
        aria-haspopup="listbox"
        aria-invalid={Boolean(fieldError)}
        data-validation-error={fieldError ? true : undefined}
        data-validation-field={fieldName}
        style={customDropStyles}
        ref={dropRef}
        isSelectedValue={selectedValue}
        error={fieldError}
        data-test-id={test_id}
        isRegion={isRegion}
        active={active}
        onKeyDown={handleComboboxKeyDown}
        onClick={disabled ? undefined : () => setActive((current) => !current)}
        isSmall={isSmall}
        disabled={disabled}
        multi={multi}
      >
      {isRegion && 
        <VerySmall style={{color:theme.grey[600], textTransform:"uppercase", fontSize:"8px", lineHeight:'9.68px'}}>
          {t("REGION")}
        </VerySmall>
      }
      {multi ? 
        <ControlContent>
          {selectedValue ?
            <PropsWrapper>
              {selectedValue?.map((item:any) => (
                <PropContainer key={item.id ?? item.value ?? item.label} style={{height: '30px', padding:'5px 4px 5px 6px'}}>
                  <PropMulti>
                    {item.label}
                  </PropMulti>
                  <ImgArrow
                    alt=""
                    $disabled={disabled}
                    onClick={disabled ? undefined : (event) => {
                      event.stopPropagation()
                      changeValue(item)
                    }}
                    active={false}
                    style={{width:'16px', marginLeft:'3px'}}
                    src={icons.CloseIcon}
                  />
                </PropContainer>
              ))}
              <SelectInput
                autoComplete="off"
                data-1p-ignore="true"
                data-lpignore="true"
                disabled={disabled}
                name="ocp-multi-select-search"
                ref={inputRef}
                onClick={(event) => event.stopPropagation()}
                onKeyDown={handleMultiInputKeyDown}
                onChange={(e) => setSearchString(e.target.value)}
                value={searchString}
              />
            </PropsWrapper>
          : null
          }
          <ImgArrow alt="" $disabled={disabled} active={active && !disabled} src={ArrowDown}/>
        </ControlContent>
      :
        <ControlContent>
          <SelectedValue>
            {selected?.icon ?
              <img alt="" style={{marginRight:'4px'}} src={selected?.icon} />
            : null}
            <ItemTextTitle $disabled={disabled} style={!selected ? {opacity: 0.5} : undefined}>
              {
              !selected ? placeholder || t("CHOOSE") : selected?.customItem &&
                selected?.type === 'flavor' ?
                  <ItemLabelFlavor item={selected.customItem} />
              :
               selected?.title || selected?.label}
            </ItemTextTitle>
          </SelectedValue>
            <SelectActions>
              {selected?.options ?
                <PropsWrapper>
                  {selected?.options.map((item:any) => (
                    <PropContainer key={item}>
                      <Prop>
                        {item}
                      </Prop>
                    </PropContainer>
                  ))}
                </PropsWrapper>
              : null
              }
              <ImgArrow alt="" $disabled={disabled} active={active && !disabled} src={ArrowDown}/>
            </SelectActions>
          </ControlContent>
        }
      </DropDown>
      {active && !disabled ? renderInPortal ? createPortal(
        <OptionsWrapper id={optionsId} role="listbox" aria-multiselectable={multi || undefined} ref={droppedRef} style={dropdownPosition} multi={multi} height={height} isSmall={isSmall}>
          {hasSearch &&
            <SearchField>
              <img alt="" src={icons.SearchIcon}/>
              <SearchInput
                autoComplete="off"
                data-1p-ignore="true"
                data-lpignore="true"
                name="ocp-select-search"
                ref={inputRefSearch}
                aria-label={t("SEARCH")}
                placeholder={t("SEARCH")}
                onChange={(event) => setSearchString(event.target.value)}
                value={searchString}
              />
            </SearchField>
          }
          {
            searchString?.length > 0 ?
              data?.length > 0 && data.filter((item) => String(item.label ?? item.title ?? '').toLowerCase().includes(searchString.toLowerCase()))?.length > 0 ?
               data.filter((item) => String(item.label ?? item.title ?? '').toLowerCase().includes(searchString.toLowerCase())).map((item:ListItem) => (
                 <Item
                  key={item.id ?? item.value}
                  item={item}
                  isSmall={isSmall}
                  selectedValue={selectedValue}
                  changeValue={changeValue}
                  multi={multi}
                />
              )) :
              <Option>
                <ItemText style={{whiteSpace:"nowrap"}}>
                  {t("NO_DATA_SEARCHED")}
                </ItemText>
              </Option>
            :
                categories && categories?.length > 0 ? categories?.map((category) => (
                  <div key={category.value} style={{padding:"12px 8px 12px 10px"}}>
                    <Categorytitle>
                      {category.name}
                    </Categorytitle>
                    <>
                      {data?.length > 0 && data.filter((select:any) => select.category === category.value).map((item:ListItem) => (
                        <Item
                          //@ts-ignore
                          // item={<ItemLabelFlavor item={item.customItem} image={bootImage} />}
                          item={item}
                          key={item.id ?? item.value}
                          isSmall={isSmall}
                          bootImage={bootImage}
                          selectedValue={selectedValue}
                          changeValue={changeValue}
                          multi={multi}
                        />
                      ))}
                    </>
                  </div>
                )) 
              :
                data?.length > 0 ? data.map((item:ListItem) => (
                  <Item
                    key={item.id ?? item.value}
                    //@ts-ignore
                    // item={<ItemLabelFlavor item={item.customItem} image={bootImage} />}
                    item={item}
                    isSmall={isSmall}
                    bootImage={bootImage}
                    selectedValue={selectedValue}
                    changeValue={changeValue}
                    multi={multi}
                  />
                ))
                :
                <Option>
                  <ItemText style={{whiteSpace:"nowrap"}}>
                    {t("NO_DATA")}
                  </ItemText>
                </Option>
          }
        </OptionsWrapper>,
        document.body
      ) :
        <OptionsWrapper id={optionsId} role="listbox" aria-multiselectable={multi || undefined} ref={droppedRef} multi={multi} height={height} isSmall={isSmall}>
          {hasSearch &&
            <SearchField>
              <img alt="" src={icons.SearchIcon}/>
              <SearchInput
                autoComplete="off"
                data-1p-ignore="true"
                data-lpignore="true"
                name="ocp-select-search"
                ref={inputRefSearch}
                aria-label={t("SEARCH")}
                placeholder={t("SEARCH")}
                onChange={(event) => setSearchString(event.target.value)}
                value={searchString}
              />
            </SearchField>
          }
          {
            searchString?.length > 0 ?
              data?.length > 0 && data.filter((item) => String(item.label ?? item.title ?? '').toLowerCase().includes(searchString.toLowerCase()))?.length > 0 ?
               data.filter((item) => String(item.label ?? item.title ?? '').toLowerCase().includes(searchString.toLowerCase())).map((item:ListItem) => (
                 <Item
                  key={item.id ?? item.value}
                  item={item}
                  isSmall={isSmall}
                  selectedValue={selectedValue}
                  changeValue={changeValue}
                  multi={multi}
                />
              )) :
              <Option>
                <ItemText style={{whiteSpace:"nowrap"}}>
                  {t("NO_DATA_SEARCHED")}
                </ItemText>
              </Option>
            :
                categories && categories?.length > 0 ? categories?.map((category) => (
                  <div key={category.value} style={{padding:"12px 8px 12px 10px"}}>
                    <Categorytitle>
                      {category.name}
                    </Categorytitle>
                    <>
                      {data?.length > 0 && data.filter((select:any) => select.category === category.value).map((item:ListItem) => (
                        <Item
                          //@ts-ignore
                          // item={<ItemLabelFlavor item={item.customItem} image={bootImage} />}
                          item={item}
                          key={item.id ?? item.value}
                          isSmall={isSmall}
                          bootImage={bootImage}
                          selectedValue={selectedValue}
                          changeValue={changeValue}
                          multi={multi}
                        />
                      ))}
                    </>
                  </div>
                )) 
              :
                data?.length > 0 ? data.map((item:ListItem) => (
                  <Item
                    key={item.id ?? item.value}
                    //@ts-ignore
                    // item={<ItemLabelFlavor item={item.customItem} image={bootImage} />}
                    item={item}
                    isSmall={isSmall}
                    bootImage={bootImage}
                    selectedValue={selectedValue}
                    changeValue={changeValue}
                    multi={multi}
                  />
                ))
                :
                <Option>
                  <ItemText style={{whiteSpace:"nowrap"}}>
                    {t("NO_DATA")}
                  </ItemText>
                </Option>
          }
        </OptionsWrapper>
      : null}
      {fieldError ? <ErrorText>{fieldError}</ErrorText> : null}
    </Container>
  )
}

export default Select


const Item:FC<any> = ({
  item,
  isSmall,
  selectedValue,
  changeValue,
  multi,
  bootImage
}) => {
  const blocked = bootImage ? (item.memory_mb < bootImage.min_ram || item.root_gb < bootImage.min_disk || bootImage.disksCount < item.min_disks) : false
  const itemValue = item.id ?? item.value
  const selected = multi
    ? selectedValue?.some((selectedItem:any) => (selectedItem.id ?? selectedItem.value) === itemValue)
    : itemValue === selectedValue
  const disabled = item.blocked || blocked
  const selectItem = () => {
    if (!disabled) {
      changeValue(multi ? item : itemValue)
    }
  }
  return (
    <Option
      role="option"
      tabIndex={disabled ? -1 : 0}
      aria-selected={Boolean(selected)}
      aria-disabled={disabled}
      isSmall={isSmall}
      active={selected}
      $disabled={disabled}
      onClick={selectItem}
      onKeyDown={(event) => {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault()
          selectItem()
        }
      }}
    >
      {multi && <MultiCheck $checked={Boolean(selected)} aria-hidden="true">{selected ? '✓' : ''}</MultiCheck>}
      <div 
        style={{
          width:'100%',
          display:'flex',
          alignItems:"flex-start",
          gap:'5px',
          // justifyContent:'space-between'
        }}
      >
        <div style={{display:'flex', alignItems:"center"}}>
          {item.icon ?
            <img alt="" style={{marginRight:'4px'}} src={item.icon} />
          : null}
          {isSmall ? 
            <ItemTextSmall>
              {item.title || item.add_label || item.label}
            </ItemTextSmall>
          :
            <ItemText>
              {
              item.customItem &&
              item.type === 'flavor' ?
                  <ItemLabelFlavor blockedDown={item.blockedDown} blocked={blocked || item.blocked} item={item.customItem}/>
              :
              item.type === 'disk_layout' ? 
              <ItemLabelDiskLayout blockedDown={item.blockedDown} blocked={blocked || item.blocked} item={item}/>
              :
              item.title || item.add_label || item.label}
            </ItemText>
          }
        </div>
        <div style={{display:'flex', alignItems:"center"}}>
          {item?.options && !multi ?
            <PropsWrapper>
              {item?.options.map((item:any) => (
                <PropContainer key={item}>
                  <Prop>
                    {item}
                  </Prop>
                </PropContainer>
              ))}
            </PropsWrapper>
          : null
          }
        </div>
      </div>
    </Option>
  )
}
export const ItemLabelDiskLayout:FC<any> = ({item, blocked, blockedDown, withoutPrice}) => {
  const [t] = useTranslation()
  return (
    <div style={{display:'flex', flexDirection:"column"}}>
      <ItemFlavor style={{justifyContent:'flex-start'}} block={blocked}>
        <BodyDefault>
          {item?.label}
        </BodyDefault>
        <div style={{display:'flex', alignItems:'center', gap:'6px'}}>
          <PropContainer>
            <Prop>
            {t("MIN_DISKS")}-{item?.min_disks || 1}
            </Prop>
          </PropContainer>
        </div>
      </ItemFlavor>
      {blocked && !blockedDown ? <ErrorText style={{fontSize:'12px', marginTop:'0px'}}>{t("INCOMPATIBLE_DISK_LAYOUT")}</ErrorText> : null}
    </div>
  )
}

export const ItemLabelFlavor:FC<any> = ({item, blocked, blockedDown, withoutPrice}) => {
  const [t] = useTranslation()
  return (
    <div style={{display:'flex', flexDirection:"column"}}>
      <ItemFlavor block={blocked}>
        <BodyDefault>
          {item?.name}
        </BodyDefault>
        <div style={{display:'flex', alignItems:'center', gap:'6px'}}>
          <PropContainer>
            <Prop>
              {item?.vcpus} CPU
            </Prop>
          </PropContainer>
          <PropContainer>
            <Prop>
              {item?.memory_gb}GB RAM
            </Prop>
          </PropContainer>
          {!withoutPrice &&
            <PropContainer>
              <Prop>
                {item.estimate}
              </Prop>
            </PropContainer>
          }
        </div>
      </ItemFlavor>
      {blocked && !blockedDown ? <ErrorText style={{fontSize:'12px', marginTop:'0px'}}>{t("INCOMPATIBLE_FLAVOR")}</ErrorText> : null}
    </div>
  )
}
